<div class="contentModal">
  <h1 mat-dialog-title style="color: #3074AA;"><Strong>{{ infoContratos.titulo }} </Strong></h1>
  <div mat-dialog-content class="mat-typography">

    <mat-card class="card">

      <div *ngIf="(this.visualizaContratoPF)">
        <app-contrato-amplo-pf [infoContratos]="infoContratos"></app-contrato-amplo-pf>
      </div>

      <div *ngIf="(this.visualizaContratoPJ)">
        <app-contrato-amplo [infoContratos]="infoContratos"></app-contrato-amplo>
      </div>

      <div *ngIf="(this.visualizaRenovaContratoPF)">
        <app-renova-contrato-amplo-pf [infoContratos]="infoContratos"></app-renova-contrato-amplo-pf>
      </div>

      <div *ngIf="(this.visualizaRenovaContratoPJ)">
        <app-renova-contrato-amplo-pj [infoContratos]="infoContratos"></app-renova-contrato-amplo-pj>
      </div>

</mat-card>
  </div>

  <div mat-dialog-actions class="botoes">
    <button mat-raised-button class="md-icon-button btnNok" (click)="onClose()">
      <img class="img-fluid" src="assets/icons/white_close_icon.png" width="16px" /> Fechar
    </button>
  </div>
</div>